import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import type { Components } from 'react-markdown'

const blogMarkdownComponents: Components = {
  a: ({ href, children }) => {
    const isInternal = href?.startsWith('/') && !href.startsWith('//')
    if (isInternal && href) {
      return <Link to={href}>{children}</Link>
    }
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    )
  },
  img: ({ src, alt, title }) => {
    if (alt?.startsWith('video:')) {
      const caption = alt.slice(6).trim()
      return (
        <figure className="blog-media-figure">
          <video
            src={src}
            poster={title || undefined}
            controls
            playsInline
            preload="metadata"
            className="blog-article-video"
          />
          {caption ? <figcaption className="blog-media-caption">{caption}</figcaption> : null}
        </figure>
      )
    }
    return (
      <figure className="blog-media-figure">
        <img
          src={src}
          alt={alt || ''}
          title={title || undefined}
          className="blog-article-img"
          loading="lazy"
        />
        {alt ? <figcaption className="blog-media-caption">{alt}</figcaption> : null}
      </figure>
    )
  },
}

type BlogMarkdownContentProps = {
  content: string
  className?: string
}

export default function BlogMarkdownContent({ content, className }: BlogMarkdownContentProps) {
  return (
    <div className={className}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={blogMarkdownComponents}>
        {content}
      </ReactMarkdown>
    </div>
  )
}
